import { forwardRef } from 'react'
import { LinkProps } from 'react-router'

import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'



export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
export type AnchorProps = LinkProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

export interface ButtonComponentProps extends Partial<ButtonProps & AnchorProps> {
  to?: string
  size?: 'small' | 'medium' | 'large'
  theme?: 'primary' | 'secondary' | 'grey' | 'white' | 'quaternary'
  loading?: boolean
}

const Button = forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ButtonComponentProps
>(
  (
    { to, children, className, theme = 'primary', size = 'medium', loading, ...props },
    ref,
  ) => {
    if (to) {
      return (
        <Link
          to={to}
          ref={ref as React.Ref<HTMLAnchorElement>}
          className={cn(styles.root, className, styles[theme], styles[size])}
          aria-busy={loading}
          {...props}
        >
          {children}
        </Link>
      )
    }

    return (
      <button
        type="button"
        ref={ref as React.Ref<HTMLButtonElement>}
        className={cn(
          'reset-button',
          styles.root,
          className,
          styles[theme],
          styles[size],
        )}
        aria-busy={loading}
        {...props}
        disabled={props.disabled || loading}
      >
        {children}
      </button>
    )
  },
)

Button.displayName = 'Button'

export default Button
